import React, { useState, useEffect } from "react";
import { Form, Row, Col, Divider, Dropdown, Menu, message } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import CustomInput from "../../components/CustomInput.jsx";
import CustomTitle from "../../components/CustomTitle.jsx";
import CustomButton from "../../components/CustomButton.jsx";
import TeamsSelector from "../../components/TeamsSelector.jsx";
import StatusTag from "../../components/StatusTag.jsx";
import ContactList from "./ContactList.jsx";
import { Flex, Avatar } from "antd";
import AddItemButton from "../../components/AddItemButton.jsx";
import AddNewContactModal from "../Modals/AddNewContactModal.jsx";
import infoIcon from "../../assets/images/info-icon.svg";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import NotificationBanner from "../../components/NotificationBanner.jsx";
import { getTeamsDDL, getTeamsDDLOFFeature } from "../../common/utils/dropDown";
import useToken from "../../common/helper/usetoken.js";
import { LinkSettingsCourierAccount, GetSettingsNewCouriersById } from "../../api's/settings.js";
import { useSpin } from "../../components/SpinContext.js";
import { useNavigate } from "react-router-dom";
import { courier } from "../../reudx-toolkit/slice/onboardingSlice.js";
import TeamsSelectorCheckbox from "../../components/TeamsSelectorCheckbox.jsx";
import Img from "../../assets/images/default icon.png"
import { getProviderImagePath } from '../../common/utils/imageUtils';
import { useSelector } from "react-redux";

const ProviderDetailsHeader = ({ provider, edit, handleMenuClick }) => {

  const menu = (
    <Menu onClick={({ key }) => handleMenuClick(key)}>
      <Menu.Item key="connection">
        <span style={{ color: "#000" }}>Change credentials</span>
      </Menu.Item>
      <Menu.Item key="delete" style={{ color: "red" }}>
        Remove
      </Menu.Item>
    </Menu>
  );

  return (
    <div style={{ paddingBottom: "20px", position: "relative" }}>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={12}>
          <Avatar
          src={
            <img
            src={getProviderImagePath(provider?.title || provider?.courier_name, 'transportProvider')}
              alt="avatar"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
         
            size={50}
            style={{
              backgroundColor: "transparent",
              fontSize: "18px",
              fontWeight: "bold",
              color: "#333",
            }}
          >
            {/* {provider?.logo ? (
              <img
                src={provider?.logo}
                alt={provider?.title || provider?.courier_name}
                style={{ width: "100%", height: "100%", borderRadius: "50%" }}
              />
            ) : (
              provider?.title || provider?.courier_name?.charAt(0)
            )} */}
          </Avatar>
          <Flex vertical>
            <CustomTitle
              marginBottom={"5px"}
              text={provider?.courier_name || provider?.title}
              fontSize={24}
              fontWeight="700"
              color="#000"
            />
            <StatusTag status={provider?.value=="new" ? "pending" : (provider?.value == "basic" ? 
              "basic" : provider?.status
            )} />
          </Flex>
        </Flex>

        {edit && (
          <Dropdown overlay={menu} trigger={["click"]}>
            <div
              style={{
                width: "28px",
                height: "28px",
                backgroundColor: "#EEEEEE",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "background 0.2s ease-in-out",
                position:"absolute",
                right:"46px"
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#E0E0E0")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "#F3F3F3")
              }
            >
              <EllipsisOutlined style={{ fontSize: "16px", color: "#000" }} />
            </div>
          </Dropdown>
        )}
      </Flex>
    </div>
  );
};

const TransportProviderDetails = ({
  providerData,
  onClose,
  edit,
  setModalState,
  recordId=null,
  courierId=null

}) => {
  const [form] = Form.useForm();
  const [contactForm] = Form.useForm();
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken } = useToken();
  const [isFormValid, setIsFormValid] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editingContact, setEditingContact] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [notification, setNotification] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [contactList, setContactList] = useState(providerData?.contacts || []);
  const [objID,setObjectID] = useState(null);
  const [contactIndex,setContactIndex] = useState(-1);
  //get Products type AND teams for drop down

  const teamsList = useSelector((state) => state.teams.list);

  const hasValidTeams = !(
    teamsList.length === 0 ||
    (teamsList.length === 1 && teamsList[0].name.toLowerCase() === "default")
  );


  const [allTeams, setAllTeams] = useState([]);

   useEffect(() => {
      getTeamsDDLOFFeature(token,"Transport providers").then((val) => {
        if (val && val.length > 0) {
          setAllTeams(val);
        }
      });
    }, []); 

  useEffect(() => {
    if (edit === true && recordId) {
      setObjectID(recordId)
      GetSingleSettingsNewCourier();
    }

  }, [edit, providerData])

  const GetSingleSettingsNewCourier = () => {
    showSpin();
    GetSettingsNewCouriersById(recordId, token)
      .then((res) => {
        
        const data = res?.data?.data?.data?.object ? res?.data?.data?.data?.object : null;
        form.setFieldsValue({
          name: data.courier_name || "",
          description: data.description || "",
          teams:data.teams || "",
        });
        
        if (data?.teams) {
          setSelectedTeams(data.teams);
        }
        if (data?.contact) {
          setContactList(data?.contact)
        }

      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  }


  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const handleSaveContact = (contact) => {
    const isEditing = !!editingContact;
  
    if (contact.is_primary_contact) {
      const alreadyPrimary = contactList.some((c,index) =>
        c.is_primary_contact && (!isEditing || index !== contactIndex)
      );
  
      if (alreadyPrimary) {
        message.error("Only one primary contact can be selected.");
        return;
      }
    }
  
    if (isEditing) {
      setContactList((prevContacts) =>
        prevContacts.map((c,index) =>
          index === contactIndex ? { ...c, ...contact } : c
        )
      );
    } else {
      const newContact = {
        ...contact,
       // id: Date.now(),
        country_code: contact.country_code || "", // optional fallback
      };
      setContactList((prevContacts) => [...prevContacts, newContact]);
    }
  
    setOpenModal(false);
    contactForm.resetFields();
    setEditingContact(null);
  };
  

  const handleMenuClick = (key) => {
    setModalState((prev) => ({ ...prev, [key]: true }));
  };
  // const teamsOptions = [
  //   { name: "Oncology", color: "#F19898" },
  //   { name: "Vaccines", color: "#F4D35E" },
  //   { name: "Internal medicine", color: "#48C9B0" },
  //   { name: "Specialty pharma", color: "#A3E4D7" },
  //   { name: "Hospital", color: "#BB8FCE" },
  // ];



  useEffect(() => {
    if (providerData) {
      form.setFieldsValue({
        name: providerData?.courier_name || providerData?.title || "",
        description: providerData?.description || "",
      });

      if (providerData?.teams) {
        setSelectedTeams(providerData.teams);
      }
    }
  }, [providerData, form]);

  const handleEditContact = (contact,index) => {
    setEditingContact(contact);
    setContactIndex(index);
    contactForm.setFieldsValue({
      name: contact.name,
      title: contact.title,
      email: contact.email,
      country_code: '',
      phone_number: contact.phone_number,
      is_primary_contact: contact.is_primary_contact,
    });
    setOpenModal(true);
  };

  const handleAddNewContact = () => {
    setEditingContact(null);
    contactForm.resetFields();
    setOpenModal(true);
  };
  const handleDeleteClick = (contact,index) => {
    setContactIndex(index);
    setContactToDelete(contact);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = () => {
    if (!contactToDelete) return;

    // setContactList((prevContacts) =>
    //   prevContacts.filter((contact) => contact.id !== contactToDelete.id)
    // );
     setContactList((prevContacts) =>
      prevContacts.filter((contact,ind) => ind !== contactIndex)
    );
    setDeleteModalVisible(false);
    setContactToDelete(null);
  };

  //OnSubmit form
  const onFinish = (values) => {
    const teamIds = selectedTeams.map((team) => team.id);
    if (values && Object.keys(values).length > 0) {
      let model = {
        ...form.getFieldsValue(),
        // ...providerData,
        ...{ contacts: contactList },
        ...{ teams: teamIds }

      };
      if (courierId) {
        model.courier = courierId;
        //model.client_id=providerData?.courier_id
       // model.client_secret=providerData?.courier_id
      }

      if (providerData?.credentials) {
        model.credentials = providerData.credentials
      }

      const countContacts =
        model?.contacts &&
        model?.contacts.filter((item) => item?.is_primary_contact === true);
      // if (countContacts?.length === 1) {
      //   LinkCouriers(model);
      // } else if (countContacts?.length < 1) {
      //   message.error("Please select at least one primary contact.");
      // } else {
      //   message.error("Only one primary contact can be selected.");
      // }

      if (countContacts.length <= 1) {
        
        LinkCouriers(model);
      } else {
        message.error("Only one primary contact can be selected.");
      }

    }
  };

  const LinkCouriers = (model) => {
    if(edit===true){
      model.id=objID
    }
    setIsFormValid(true);
    showSpin();
    LinkSettingsCourierAccount(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data.is_success) {
            onClose();
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((err) => {
        unauthorize(err);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };


  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          style={{ position: "absolute", top: "40px", background: "#fff", zIndex: 10, width: "100%" }}
        >
          <ProviderDetailsHeader
            provider={providerData}
            edit={edit}
            handleMenuClick={handleMenuClick}
          />
        </div>
        {notification && (
          <NotificationBanner
            icon={infoIcon}
            message="A ZoomLogi representative will reach out to you to complete integration"
          />
        )}
        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "130px",
            paddingTop: "54px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          <Row gutter={[16, 14]}>
            <Col span={24}>
              <Form.Item className="custom-input form-input-style" label="Description" rules={[{ required: false, message: "Please enter description" }]} name="description">
                <CustomInput
                  placeholder={`Enter provider description`}
                  bgColor="#F3F3F3"
                  height="36px"
                  textColor="#000000"
                  borderRadius="8px"
                  border="none"
                  placeholderColor="#5E5E5E"
                />
              </Form.Item>
            </Col>

            {hasValidTeams && 
            <Col span={24}>
              {/* <CustomTitle
                text="Team(s)"
                fontSize={12}
                fontWeight="600"
                marginTop="0px"
              /> */}
              <Form.Item className="custom-input form-input-style" label="Team(s)" rules={[{ required: true, message: "Please select value" }]}  name="teams">
                 {/* <TeamsSelectorCheckbox
                    teamsOptions={allTeams}
                    selectedTeams={selectedTeams}
                    setSelectedTeams={setSelectedTeams}
                    onChange={setSelectedTeams}
                  /> */}
                    <TeamsSelector
                 teamsOptions={allTeams}
                 selectedTeams={selectedTeams}
                 onChange={setSelectedTeams}
                 formState={edit===true ? "edit" : "add"}
                />
              </Form.Item>
            </Col>
            }

            <Col span={24}>
              <Divider style={{ borderColor: "#D9D9D9", margin: "0px" }} />
            </Col>
            <Col span={24}>
              <CustomTitle text="Contacts"  marginBottom={contactList?.length>0 ? "-8px" : "0px"} fontSize={16} fontWeight="700" />
            </Col>
            {contactList?.length > 0 && (
              <Col span={24}>
                <ContactList
                  data={contactList}
                  handleEdit={handleEditContact}
                  handleDeleteClick={handleDeleteClick}
                />
              </Col>
            )}
            <Col span={24}>
              <AddItemButton
              marginTop="0px"
                text="Add Contact"
                fontSize="12px"
                fontWeight="600"
                onClick={handleAddNewContact}
              />
            </Col>




          </Row>
        </div>

        <div
          style={{
            background: "#fff",
            position: "absolute",
            bottom: "0",
            left: "0",
            width: "100%",
            padding: "16px",
          }}
        >
          <CustomButton
            text="Save"
            bgColor="#000"
            htmlType="submit"
            color="#fff"
            fontSize="16px"
            fontWeight="600"
            height="45px"
            width="100%"
          />
          <CustomButton
            boxShadow={"none"}
            text="Cancel"
            bgColor="transparent"
            color="#000"
            fontSize="16px"
            fontWeight="400"
            height="auto"
            width="100%"
            border="none"
            marginTop="20px"
            marginBottom="10px"
            onClick={onClose}
          />
        </div>
      </Form>
      <CustomDeleteModal
        visible={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onConfirm={handleConfirmDelete}
        title="Remove Contact"
        message="Removing this contact will prevent selecting it for future use."
        cancelText="Cancel"
        confirmText="Remove"
        confirmColor="#DE1135"
      />
      <AddNewContactModal
        title={editingContact ? "Edit contact" : "Add contact"}
        form={contactForm}
        modalOpen={openModal}
        setModalOpen={setOpenModal}
        setEditingContact={setEditingContact}
        apiCall={handleSaveContact}
        isFormValid={true}
      />
    </>
  );
};

export default TransportProviderDetails;
